/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Novel_Candid_Otter_NurtureInputs */

const fr_novel_candid_otter_nurture = /** @type {(inputs: Novel_Candid_Otter_NurtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytique`)
};

/**

* @param {Novel_Candid_Otter_NurtureInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const novel_candid_otter_nurture = /** @type {((inputs?: Novel_Candid_Otter_NurtureInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Novel_Candid_Otter_NurtureInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_novel_candid_otter_nurture(inputs)
});